import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import Swiper from 'swiper';
import SwiperCss from '../../../node_modules/swiper/dist/css/swiper.min.css';
import modaalCss from '../../../node_modules/modaal/dist/css/modaal.css';
import modaal from 'modaal';
import Rellax from 'rellax';
import ScrollReveal from "scrollreveal";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    // flex-box gallery.js - 読み込み
    $.fn.flexgal = function () {
      $('body').prepend('<div id="fullimage" style="display: none"></div>')
      $(this).addClass('flex-gallery');
      $('img', this).parent().addClass('image-rate');
    }

    // TOP - カルーセル
    function carousel() {
      var galleryThumbs = new Swiper('.gallery-thumbs', {
        slidesPerView: 'auto',
        watchOverflow: true,
        loop: false,
        autoplay: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          750: {
            slidesPerView: 5,
            loop: false,
            freeMode: true,
          }
        }
      });
      var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 0,
        slidesPerView: 'auto',
        grabCursor: true,
        loop: true,
        centeredSlides: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 70,
          stretch: 0,
          depth: 250,
          modifier: 1,
          slideShadows: true,
        },
        autoplay: false,
        uniqueNavElements: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',

        },
        thumbs: {
          swiper: galleryThumbs,
        },
        breakpoints: {
          750: {
            coverflowEffect: {
              rotate: 60,
              stretch: 0,
              depth: 250,
              modifier: 1,
              slideShadows: true,
            },
          }
        }
      });
    }

    // TOP - スクロールドット
    function scrollDots() {
      if ($(".c-dot-navi").length <= 0) {
        return;
      }
      var offset = -240;
      var el1 = $(".c-dot-navi li:nth-child(1) a").attr("data-anchor-target");
      var el1_start_pos = $(el1)[0].offsetTop + offset;
      var el2 = $(".c-dot-navi li:nth-child(2) a").attr("data-anchor-target");
      var el2_start_pos = $(el2)[0].offsetTop + offset;
      var el3 = $(".c-dot-navi li:nth-child(3) a").attr("data-anchor-target");
      var el3_start_pos = $(el3)[0].offsetTop + offset;
      var el4 = $(".c-dot-navi li:nth-child(4) a").attr("data-anchor-target");
      var el4_start_pos = $(el4)[0].offsetTop + offset;
      var el5 = $(".c-dot-navi li:last-child a").attr("data-anchor-target");
      var el5_start_pos = $(el5)[0].offsetTop + offset;
      var start_pos = el1_start_pos + $(el1).height() + offset;
      var end_pos = $(el5)[0].offsetTop + $(el5)[0].offsetHeight + offset;

      $(window).on('scroll', function (event) {
        var scroll_top = $(window).scrollTop();

        if (scroll_top >= start_pos) {
          $(".c-dot-navi").addClass("is-enable");

          if (scroll_top >= el5_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(5)").addClass("is-active");
          } else if (scroll_top >= el4_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(4)").addClass("is-active");
          } else if (scroll_top >= el3_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(3)").addClass("is-active");
          } else if (scroll_top >= el2_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(2)").addClass("is-active");
          } else if (scroll_top >= el1_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(1)").addClass("is-active");
          }

        }

        if (scroll_top >= end_pos || scroll_top <= start_pos) {
          $(".c-dot-navi").removeClass("is-enable");
        }


      });
    }

    // ポップアップ
    function modal() {
      $(".c-greeting__block").modaal();
      $(".c-file__link").modaal();
      $(".file .c-gallery__image").modaal();
      $('.c-main-visual__icon-button').modaal({
        type: 'video',
        fullscreen: true
      });

      $(".c-greeting__block").on("click", function () {
        $('.modaal-wrapper').addClass('is-greeting');
      });
    }

    // 施工ファイル - フェイドイン
    function gallery() {
      $(document).ready(function () {
        $('.c-gallery').hide();
        $(".c-gallery .c-gallery__image").hide();
        $('.c-gallery__inner').imagesLoaded(function () {
          $.when(
            $('.c-gallery__inner').flexgal()
          ).done(function () {
            $('.c-gallery').show();
            $(".c-gallery .c-gallery__image").each(function (i, e) {
              var delaytime = Math.floor(Math.random()  * 1000);
              $.when(
                $(e).delay(delaytime).show()
              ).done(function () {
                $(e).css("opacity", 1);
              });
            });
          });
        });
      });
    }

    // 50年のあゆみ - パララックス
    function parallax() {
      var rellax = new Rellax('.c-history-content__parallax', {
        speed: -2,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
      });
    }

    // TOP - カウントアップ
    function numberCountUp(callback) {
      var selector = '.js-countup';     // 対象のDOMのセレクタ
      var $years = $(selector);
      $years.each(function () {
        var start_year = $(this).attr("data-start")*1;
        var end_year = $(this).attr("data-end")*1;
        $(this).text(start_year);
        var tempyear = start_year;
        var self = this;
        var interval = setInterval(function () {
          if (tempyear < end_year) {
            tempyear++;
            $(self).text(tempyear);
          } else {
            clearInterval(interval);
            callback();
            return false;
          }
        }, 10);
      });
    }

    // TOP - オープニング
    function mainVisual() {
      //変数宣言
      let video = document.querySelector('video');
      let $mainVisualInner = $(".c-main-visual__inner");
      let $mainVisualScroll = $(".c-main-visual__scroll");
      let $header = $(".l-header");
      let $slidebarBtn = $(".c-slidebar-button");
      let $dotNav = $(".c-dot-navi");
      let $countup = $(".c-count-up");

      //処理1
      function fadeOut() {
        let delay = 1000;
        setTimeout(function () {
          $countup.find(".js-countup").fadeOut();
          $countup.addClass('is-color-bold');
        }, delay);
      }

      //処理2
      function titleIn() {
        let delay = 1500;
        setTimeout(function () {
          $mainVisualInner.addClass('is-visible');
          $mainVisualInner.addClass('is-active');
        }, delay);
        setTimeout(function () {
          $countup.addClass('is-hidden');
        }, delay+1000);
      }

      //処理3
      function slideIn() {
        let delay = 3500;
        setTimeout(function () {
          $countup.hide();
          $header.addClass('is-active');
          $slidebarBtn.addClass('is-active');
          $dotNav.addClass('is-active');
          $mainVisualScroll.addClass('is-active');
        }, delay);
      }

      //処理4
      function videoShow() {
        let delay = 4500;
        setTimeout(function () {
          video.play();
          $('.c-main-visual__text').css('opacity', '0');
          $('.c-main-visual__subtext').css('opacity', '0');
          document.removeEventListener("mousewheel", scroll_control, {passive: false});
          document.removeEventListener('touchmove', scroll_control, {passive: false});
          document.removeEventListener('wheel', scroll_control, {passive: false});
        }, delay);
      }

      //実行
      fadeOut();
      titleIn();
      slideIn();
      videoShow();
    }

    // スクロールリーバル
    function scrollReveal() {
      window.sr = ScrollReveal({easing: 'ease-in-out'});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      sr.reveal(".c-history__ad", {scale: 1, duration: 600, delay: 100, origin: 'bottom', distance: '20px',}, 100);
      sr.reveal(".c-history__text, .c-page-header__text", {
        scale: 1,
        duration: 600,
        delay: 300,
        origin: 'bottom',
        distance: '20px',
      }, 100);
      sr.reveal(".c-history-content__title small", {
        scale: 1,
        duration: 600,
        delay: 300,
        origin: 'left',
        distance: '20px',
      }, 100);
      sr.reveal(".c-history-content__title span", {
        scale: 1,
        duration: 600,
        delay: 500,
        origin: 'left',
        distance: '20px',
      }, 100);
      sr.reveal(".c-history-graph ul li", {
        scale: 1,
        duration: 300,
        delay: 300,
        origin: 'left',
        distance: '20px',
      }, 300);
      var blocks01 = $(".c-greeting__inner, .c-file__inner");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 700, delay: 300}, 200);
        sr.reveal(item.children[1], {delay: 400, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[2], {delay: 500, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[3], {delay: 600, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[4], {delay: 700, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[5], {delay: 800, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[6], {delay: 900, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[7], {delay: 1400, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[8], {delay: 1500, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[9], {delay: 1600, scale: 1, origin: 'bottom', distance: '20px'}, 300);
        sr.reveal(item.children[10], {delay: 1700, scale: 1, origin: 'bottom', distance: '20px'}, 300);
      });

      function myCallback(el) {
        el.classList.add('is-animating');
      }

      ScrollReveal().reveal('.is-animate', {beforeReveal: myCallback});
      ScrollReveal().reveal('.c-history-content__image', {beforeReveal: myCallback});
      ScrollReveal().reveal('.c-history-graph ul li', {beforeReveal: myCallback});
    }

    $(function () {
      $(window).on('load', function() {
        if ($("body.top") && !$(location).attr('hash')) {
          // numberCountUp(mainVisual);
        }
      });
      if ($("body").hasClass('top') && !$(location).attr('hash')) {
        $.when(
          $('html,body').animate({ scrollTop: 0 })
        ).done(function(){
          $('.c-count-up').css('visibility', 'visible');
          numberCountUp(mainVisual);
        });
      }
      scrollDots();
      modal();
      carousel();
      gallery();
      parallax();
      scrollReveal();
    });
  }
}

if (!$(".c-main-visual") || $(location).attr('hash')) {
  let $mainVisualInner = $(".c-main-visual__inner");
  let $mainVisualScroll = $(".c-main-visual__scroll");
  let $header = $(".l-header");
  let $slidebarBtn = $(".c-slidebar-button");
  let $dotNav = $(".c-dot-navi");
  let video = document.querySelector('video');
  $mainVisualInner.css("opacity", 1);
  $mainVisualInner.addClass('is-active');
  $header.addClass('is-active');
  $slidebarBtn.addClass('is-active');
  $dotNav.addClass('is-active');
  $mainVisualScroll.addClass('is-active');
  video.play();
  $('.c-main-visual__text').css('opacity', '0');
  $('.c-main-visual__subtext').css('opacity', '0');
  document.removeEventListener("mousewheel", scroll_control, {passive: false});
  document.removeEventListener('touchmove', scroll_control, {passive: false});
  document.removeEventListener('wheel', scroll_control, {passive: false});
}

window.GApp = new App();
